import { useCallback } from "react";

/**
 * Revela una sección la primera vez que entra en pantalla añadiendo la clase
 * `in-view`; la animación vive en CSS y respeta `prefers-reduced-motion`.
 */
export function useReveal() {
  return useCallback((element: HTMLElement | null) => {
    if (!element) return;
    if (!("IntersectionObserver" in window)) {
      element.classList.add("in-view");
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("in-view");
        observer.disconnect();
      },
      { rootMargin: "0px 0px -60px 0px" },
    );
    observer.observe(element);
  }, []);
}
